document.addEventListener('DOMContentLoaded', function() {

  /**
   * ============================================================================
   * WOD PREORDER NOW APP PROTECTION - v7
   * ============================================================================
   * The WOD Preorder Now app loads via Shopify App Embed (can't be disabled per-template).
   * WOD may replace the entire button innerHTML, invalidating our observers.
   * v7 fix: Observe the button's childList directly and re-query textEl on each check.
   * ============================================================================
   */
  (function protectProduct2025Buttons() {
    var ENFORCE_INTERVAL_FAST = 10;    // ULTRA aggressive: every 10ms
    var ENFORCE_INTERVAL_SLOW = 50;    // Still aggressive: every 50ms
    var FAST_DURATION = 5000;          // Stay fast for 5 seconds after each state change
    
    // Store the intended button state - use a simple approach: one button per section
    var buttonStates = {};
    var enforceCount = 0;
    var stateChangeCount = 0;
    var lastStateChangeTime = 0;
    var currentInterval = null;
    var intervalId = null;
    
    // SPECIFIC selector for the Add to Cart button only - must have data-add-to-cart attribute
    function findAddToCartButton() {
      // Primary: button with data-add-to-cart attribute inside Product2025Section
      var btn = document.querySelector('.Product2025Section button[data-add-to-cart]');
      if (btn) return btn;
      
      // Fallback: button inside Product2025Form with type submit
      btn = document.querySelector('form.Product2025Form button[type="submit"]');
      if (btn) return btn;
      
      return null;
    }
    
    function getButtonKey(btn) {
      var section = btn.closest('.Product2025Section') || btn.closest('form.Product2025Form');
      if (section) {
        return section.id || 'product2025-section-0';
      }
      return 'product2025-default';
    }
    
    // Get button text - try multiple approaches
    function getButtonText(btn) {
      // First try: data-add-to-cart-text element
      var textEl = btn.querySelector('[data-add-to-cart-text]');
      if (textEl) {
        var text = textEl.textContent.trim();
        if (text) return text;
      }
      
      // Second try: any span with actual text
      var spans = btn.querySelectorAll('span');
      for (var i = 0; i < spans.length; i++) {
        var span = spans[i];
        if (!span.querySelector('svg')) {
          var text = span.textContent.trim();
          if (text && text.length > 1) return text;
        }
      }
      
      // Third try: button's direct text content
      var btnText = btn.textContent.trim();
      if (btnText) return btnText;
      
      return '';
    }
    
    // Set button text - ensure it sticks by using multiple methods
    function setButtonText(btn, text) {
      // Method 1: Set data-add-to-cart-text element
      var textEl = btn.querySelector('[data-add-to-cart-text]');
      if (textEl) {
        textEl.textContent = text;
        return true;
      }
      
      // Method 2: Find first non-icon span
      var spans = btn.querySelectorAll('span');
      for (var i = 0; i < spans.length; i++) {
        var span = spans[i];
        if (!span.querySelector('svg') && !span.querySelector('path')) {
          span.textContent = text;
          return true;
        }
      }
      
      // Method 3: Create/update the text element if structure was destroyed
      // Check if button has the expected structure, if not, recreate it
      var newSpan = document.createElement('span');
      newSpan.setAttribute('data-add-to-cart-text', '');
      newSpan.textContent = text;
      
      // Clear existing text nodes but keep other elements
      Array.from(btn.childNodes).forEach(function(node) {
        if (node.nodeType === 3) { // Text node
          btn.removeChild(node);
        }
      });
      
      btn.insertBefore(newSpan, btn.firstChild);
      return true;
    }
    
    function setButtonState(btn, text, disabled) {
      var key = getButtonKey(btn);
      buttonStates[key] = { text: text, disabled: disabled };
      lastStateChangeTime = Date.now();
      stateChangeCount++;
      
      console.log('[Product2025-v7] State set #' + stateChangeCount + ' for key:', key, '→', text);
      
      var currentText = getButtonText(btn);
      if (currentText && currentText !== text) {
        console.log('[Product2025-v7] Immediately setting button text to:', text, '(was:', currentText + ')');
        setButtonText(btn, text);
      }
      if (btn.disabled !== disabled) {
        btn.disabled = disabled;
      }
      
      // ALWAYS switch to fast mode on state change
      startFastEnforcement();
    }
    
    function enforceButtonState(btn) {
      var key = getButtonKey(btn);
      var state = buttonStates[key];
      
      if (!state) return false;
      
      var currentText = getButtonText(btn);
      
      // If text is empty or doesn't match, force update
      if (!currentText || currentText !== state.text) {
        console.log('[Product2025-v7] *** OVERRIDE DETECTED! *** count:', enforceCount, '| Reverting:', '"' + currentText + '"', '→', state.text);
        setButtonText(btn, state.text);
        return true;
      }
      if (btn.disabled !== state.disabled) {
        btn.disabled = state.disabled;
      }
      return false;
    }
    
    function enforceAllButtons() {
      enforceCount++;
      
      // Only enforce the specific Add to Cart button
      var btn = findAddToCartButton();
      if (btn) {
        enforceButtonState(btn);
      }
      
      // Detailed logging
      var timeSinceChange = Date.now() - lastStateChangeTime;
      if (timeSinceChange < 2000 || enforceCount <= 50 || enforceCount % 200 === 0) {
        var currentText = btn ? getButtonText(btn) : 'NO_BUTTON';
        var key = btn ? getButtonKey(btn) : 'NO_KEY';
        var state = buttonStates[key];
        
        if (enforceCount <= 20 || enforceCount % 50 === 0) {
          console.log('[Product2025-v7] Enforce #' + enforceCount + 
            ' | DOM text: "' + currentText + 
            '" | Expected: "' + (state ? state.text : 'NO_STATE') + 
            '" | Match:', currentText === (state ? state.text : null));
        }
      }
      
      // Check if we should slow down
      if (currentInterval === ENFORCE_INTERVAL_FAST && lastStateChangeTime > 0) {
        var timeSinceStateChange = Date.now() - lastStateChangeTime;
        if (timeSinceStateChange > FAST_DURATION) {
          startSlowEnforcement();
        }
      }
    }
    
    function startFastEnforcement() {
      if (intervalId) clearInterval(intervalId);
      currentInterval = ENFORCE_INTERVAL_FAST;
      intervalId = setInterval(enforceAllButtons, ENFORCE_INTERVAL_FAST);
      console.log('[Product2025-v7] Fast enforcement started (10ms) at stateChange #' + stateChangeCount);
    }
    
    function startSlowEnforcement() {
      if (intervalId) clearInterval(intervalId);
      currentInterval = ENFORCE_INTERVAL_SLOW;
      intervalId = setInterval(enforceAllButtons, ENFORCE_INTERVAL_SLOW);
      console.log('[Product2025-v7] Slow enforcement started (50ms) after', (Date.now() - lastStateChangeTime), 'ms');
    }
    
    // Start with fast enforcement
    startFastEnforcement();
    
    // MutationObserver on button's childList to catch innerHTML replacements
    function observeButton(btn) {
      var observer = new MutationObserver(function(mutations) {
        // Immediate enforcement when button content changes
        setTimeout(function() { enforceButtonState(btn); }, 0);
        setTimeout(function() { enforceButtonState(btn); }, 10);
      });
      
      // Watch for ANY changes to button's children (catches innerHTML replacement)
      observer.observe(btn, { 
        childList: true, 
        subtree: true, 
        characterData: true,
        attributes: true
      });
    }
    
    // Observe existing buttons
    document.querySelectorAll('.Product2025Section button[data-add-to-cart]').forEach(observeButton);
    
    // Watch for new buttons being added to page
    var bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var btns = node.querySelectorAll ? node.querySelectorAll('.Product2025Section button[data-add-to-cart]') : [];
            btns.forEach(function(btn) {
              observeButton(btn);
              enforceButtonState(btn);
            });
            if (node.matches && node.matches('.Product2025Section button[data-add-to-cart]')) {
              observeButton(node);
              enforceButtonState(node);
            }
          }
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    
    // Expose setButtonState for updatePreorderButton to use
    window._product2025SetButtonState = setButtonState;
    
    console.log('[Product2025-v7] Button protection initialized (aggressive mode)');
  })();

  /**
   * Update the Add to Cart button text based on variant inventory status
   * Shows "Pre-order" when variant is out of stock but continues selling
   * @param {Element} sectionEl - The Product2025Section element
   * @param {Object} variant - The selected variant object from Shopify
   */
  function updatePreorderButton(sectionEl, variant) {
    var button = sectionEl.querySelector('button[data-add-to-cart]');
    if (!button) return;

    var textEl = button.querySelector('[data-add-to-cart-text]');
    if (!textEl) return;

    var defaultText = button.getAttribute('data-default-text') || textEl.getAttribute('data-default-text') || 'Add to cart';
    var preorderText = button.getAttribute('data-preorder-text') || 'Pre-order';
    var soldoutText = button.getAttribute('data-soldout-text') || 'Sold Out';

    if (!variant) {
      // Variant doesn't exist (unavailable combination)
      if (window._product2025SetButtonState) {
        window._product2025SetButtonState(button, soldoutText, true);
      } else {
        button.disabled = true;
        textEl.textContent = soldoutText;
      }
      return;
    }

    if (!variant.available) {
      // Variant exists but is sold out and won't continue selling
      if (window._product2025SetButtonState) {
        window._product2025SetButtonState(button, soldoutText, true);
      } else {
        button.disabled = true;
        textEl.textContent = soldoutText;
      }
      return;
    }

    // Variant is available - check if it's a preorder.
    // Priority: 1) preorder map (server-side inventory), 2) inventory-based detection, 3) explicit flag (least reliable)
    var isPreorder = false;
    var detectionMethod = 'none';
    try {
      if (sectionEl._product2025PreorderMap && variant.id && typeof sectionEl._product2025PreorderMap[String(variant.id)] !== 'undefined') {
        // PRIORITY 1: Use the preorder map generated from liquid template (has accurate server-side inventory data)
        isPreorder = Boolean(sectionEl._product2025PreorderMap[String(variant.id)]);
        detectionMethod = 'preorder_map';
      } else if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'continue' && typeof variant.inventory_quantity !== 'undefined') {
        // PRIORITY 2: Fallback to client-side inventory-based detection if preorder map unavailable
        isPreorder = variant.inventory_quantity <= 0;
        detectionMethod = 'inventory_detection';
      } else if (typeof variant.is_preorder !== 'undefined') {
        // PRIORITY 3: Use explicit flag only as last resort (may be stale or incorrect)
        isPreorder = Boolean(variant.is_preorder);
        detectionMethod = 'explicit_flag';
      }
    } catch (e) { 
      isPreorder = false; 
      detectionMethod = 'error';
    }

    // Debug logging - v7
    console.log('[Product2025-v7] Preorder detection:', 
      'variant:', variant.id, variant.name || variant.title,
      '| isPreorder:', isPreorder,
      '| method:', detectionMethod,
      '| mapValue:', sectionEl._product2025PreorderMap ? sectionEl._product2025PreorderMap[String(variant.id)] : 'NO_MAP',
      '| inv_qty:', variant.inventory_quantity,
      '| inv_policy:', variant.inventory_policy
    );

    // Button label is always the default "Add to cart" when purchasable; pre-order
    // state is communicated by the message block rendered below the button.
    var finalText = defaultText;

    // Use protected setter if available
    if (window._product2025SetButtonState) {
      window._product2025SetButtonState(button, finalText, false);
    } else {
      button.disabled = false;
      textEl.textContent = finalText;
    }
    console.log('[Product2025-v7] Button text set to:', finalText, '(isPreorder:', isPreorder, ')');

    // Show/hide preorder message if it exists
    var preorderMessageEl = sectionEl.querySelector('.Product2025PreorderMessage');
    if (preorderMessageEl) {
      preorderMessageEl.style.display = isPreorder ? 'block' : 'none';
    }
  }

  // Make function available globally for the section initializer
  window.updatePreorderButton = updatePreorderButton;

  // Smooth scroll to reviews
  document.querySelectorAll('.Product2025ReviewJump').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = document.querySelector('#ReviewsRegion') || document.querySelector('[aria-label="Customer reviews"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Initialize dynamic checkout buttons globally (for any existing sections)
  document.querySelectorAll('.Product2025Section').forEach(function(sectionEl) {
    initializeDynamicCheckoutButtons(sectionEl);
  });

  // Lazy reveal effect for gallery images
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.Product2025MediaItem').forEach(function(el) {
    observer.observe(el);
  });

  // Quantity +/- controls - use document-level event delegation for dynamic content
  document.addEventListener('click', function(e){
    // e.target can be a text node if the user clicks the button text in some browsers.
    // Ensure we operate on an Element before calling closest().
    var targetEl = (e.target && e.target.nodeType === 1) ? e.target : (e.target && e.target.parentElement) ? e.target.parentElement : null;
    var minus = targetEl ? targetEl.closest('[data-qty-minus]') : null;
    var plus = targetEl ? targetEl.closest('[data-qty-plus]') : null;
    if (!minus && !plus) return;

    // Find the input relative to the button's parent section
    var section = minus ? minus.closest('.Product2025Section') : plus.closest('.Product2025Section');
    if (!section) return;

    var input = section.querySelector('.Product2025QtyInput') || section.querySelector('.js-qty__num');
    if (!input) return;

    var step = parseInt(input.getAttribute('step') || '1', 10);
    if (!Number.isFinite(step) || step <= 0) step = 1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var val = parseInt(input.value || '1', 10);
    if (!Number.isFinite(val)) val = min || 1;

    if (minus) {
      val = Math.max(min || 1, val - step);
    } else if (plus) {
      val = val + step;
    }

    input.value = String(val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  // ============================================================================
  // HELPER FUNCTIONS (module scope so they're accessible everywhere)
  // ============================================================================

  // Helper function for global form handling
  function addGlobalFormHandler(formEl) {
    var cartDrawerOpened = false;

    // Override form submit method
    var originalSubmit = formEl.submit;
    formEl.submit = function() {
      // Try to show cart drawer
      try {
        document.dispatchEvent(new CustomEvent('cart:open'));
        if (window.theme && window.theme.cartDrawer) {
          window.theme.cartDrawer.open();
          cartDrawerOpened = true;
        }
      } catch (e) {}

      // Check if cart drawer opened
      setTimeout(function() {
        var cartDrawer = document.getElementById('CartDrawer');
        var isDrawerOpen = cartDrawer && cartDrawer.classList.contains('is-open') ||
                          (cartDrawer && getComputedStyle(cartDrawer).display !== 'none');

        if (!cartDrawerOpened || !isDrawerOpen) {
          // Try to update cart via AJAX without navigation
          if (window.theme && theme.AjaxProduct && formEl) {
            try {
              new theme.AjaxProduct(formEl, 'button[data-add-to-cart], button[data-cart-drawer="true"], button.Product2025AddToCart, button.Product2025CartDrawer, button.btn--full, button.add-to-cart, button[data-payment-button]');
            } catch (e) {}
          }
        }
      }, 200);

      return false;
    };

    // Also handle form submission events
    formEl.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      cartDrawerOpened = false;

      // Try to trigger cart drawer
      try {
        document.dispatchEvent(new CustomEvent('cart:open'));
        if (window.theme && window.theme.cartDrawer) {
          window.theme.cartDrawer.open();
          cartDrawerOpened = true;
        }
      } catch (e) {}

      // Check if cart drawer opened
      setTimeout(function() {
        var cartDrawer = document.getElementById('CartDrawer');
        var isDrawerOpen = cartDrawer && cartDrawer.classList.contains('is-open') ||
                          (cartDrawer && getComputedStyle(cartDrawer).display !== 'none');

        if (!cartDrawerOpened || !isDrawerOpen) {
          originalSubmit.call(formEl);
        }
      }, 200);
    });
  }

  // Helper function for fallback cart drawer handling
  function addCartDrawerFallback(buttonEl) {
    buttonEl.addEventListener('click', function(e) {
      var cartDrawerOpened = false;

      // Try to trigger the theme's cart drawer system first
      try {
        document.dispatchEvent(new CustomEvent('cart:open'));
        if (window.theme && window.theme.cartDrawer) {
          window.theme.cartDrawer.open();
          cartDrawerOpened = true;
        }
      } catch (e) {}

      // Check if cart drawer opened successfully
      setTimeout(function() {
        var cartDrawer = document.getElementById('CartDrawer');
        var isDrawerOpen = cartDrawer && cartDrawer.classList.contains('is-open') ||
                          (cartDrawer && getComputedStyle(cartDrawer).display !== 'none');

        if (!cartDrawerOpened || !isDrawerOpen) {
          // Find the form and update cart via AJAX without navigation
          var form = buttonEl.closest('form');
          if (form && window.theme && theme.AjaxProduct) {
            try {
              new theme.AjaxProduct(form, 'button[data-add-to-cart], button[data-cart-drawer="true"], button.Product2025AddToCart, button.Product2025CartDrawer, button.btn--full, button.add-to-cart, button[data-payment-button]');
            } catch (e) {}
          }
        }
      }, 200);
    });
  }

  // Show/hide variant-specific gallery media (e.g. XL/PRO bag shots) for the selected variant.
  // Variant-only figures are server-rendered hidden; the matching one is revealed and moved to
  // the top of the gallery grid. Map comes from [data-variant-media-map] in the gallery snippet.
  function updateGalleryForVariant(sectionEl, variant) {
    try {
      if (!variant) return;

      // Motion default gallery (gallery_layout: 'default'): drive the flickity slideshow to the
      // variant's featured media. The gallery's own product instance never registers its
      // variantImageChange listener (its init dies before that), so call the method directly on
      // the instance bound to the inner .Product2025DefaultGallery container.
      var defaultGallery = sectionEl.querySelector('.Product2025DefaultGallery');
      if (defaultGallery) {
        if (!variant.featured_media) return;
        var insts = (window.theme && theme.sections && theme.sections.instances)
          ? Object.values(theme.sections.instances) : [];
        for (var i = 0; i < insts.length; i++) {
          var inst = insts[i];
          if (!inst || inst.type !== 'product' || !inst.flickity || !inst.container) continue;
          if (!defaultGallery.contains(inst.container)) continue;
          try {
            inst.updateVariantImage({ detail: { variant: variant } });
            break;
          } catch (e) { /* try next instance */ }
        }
        return;
      }

      var gallery = sectionEl.querySelector('.Product2025Gallery');
      if (!gallery) return;
      var mapEl = gallery.querySelector('[data-variant-media-map]');
      if (!mapEl) return;
      var map;
      try { map = JSON.parse(mapEl.textContent || '{}'); } catch (e) { return; }
      var mediaId = variant ? map[String(variant.id)] : null;
      var gated = gallery.querySelectorAll('.Product2025MediaItem--variantOnly');
      if (!gated.length) return;
      var toShow = null;
      gated.forEach(function(fig) {
        if (mediaId && String(fig.getAttribute('data-media-id')) === String(mediaId)) {
          toShow = fig;
        } else {
          fig.hidden = true;
        }
      });
      if (toShow) {
        toShow.hidden = false;
        if (gallery.firstElementChild !== toShow) gallery.insertBefore(toShow, gallery.firstElementChild);
      }
    } catch (e) { /* ignore */ }
  }

  // Initialize theme.Variants for each Product2025 section so the theme's variant system handles matching
  document.querySelectorAll('.Product2025Section').forEach(function(sectionEl) {
    try {
      if (!window.theme || !theme.Variants) return;
      // Accept either a script tag with [data-variant-json] or [data-variants]
      var variantsJsonEl = sectionEl.querySelector('[data-variant-json]') || sectionEl.querySelector('[data-variants]');
      var variants = null;
      try {
        variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : null;
      } catch (e) {
        variants = null;
      }
      // Merge server-computed preorder flags into each variant object when available
      try {
        var preorderJsonEl = sectionEl.querySelector('[data-variant-preorder]');
        if (preorderJsonEl) {
          try {
            var preorderMap = JSON.parse(preorderJsonEl.textContent || '{}');
            if (variants && Array.isArray(variants)) {
              variants.forEach(function(v) {
                if (v && typeof v.id !== 'undefined' && typeof preorderMap[String(v.id)] !== 'undefined') {
                  v.is_preorder = Boolean(preorderMap[String(v.id)]);
                }
              });
            }
          } catch (e) {}
        }
      } catch (e) {}
      if (!variants) return;

      // Determine if a product select exists for this section so theme.Variants can update it.
      // Prefer an element annotated with data-product-select, or an element with id 'ProductSelect-<sectionId>'.
      var originalSelect = sectionEl.querySelector('[data-product-select]') || document.getElementById('ProductSelect-' + (sectionEl.getAttribute('data-section-id') || ''));
      var originalSelectorId = null;
      if (originalSelect) {
        // ensure it has an id the Variants class can reference
        if (!originalSelect.id) {
          originalSelect.id = 'ProductSelect-' + (sectionEl.getAttribute('data-section-id') || Math.floor(Math.random() * 1000000));
        }
        originalSelectorId = originalSelect.id;
      }

      // instantiate theme.Variants for this section so it will manage option inputs
      var options = {
        container: sectionEl,
        enableHistoryState: false,
        singleOptionSelector: '[data-variant-input]',
        variants: variants,
        dynamicVariantsEnabled: false
      };
      if (originalSelectorId) options.originalSelectorId = originalSelectorId;

      try {
        // store instance on the section for debugging
        sectionEl._product2025Variants = new theme.Variants(options);
      } catch (e) {
        // fall back silently
      }

      // When theme.Variants dispatches a variantChange event, update hidden input and price
      sectionEl.addEventListener('variantChange', function(evt) {
        try {
          var variant = evt && evt.detail && evt.detail.variant;
          if (!variant) return;
          var variantInput = sectionEl.querySelector('input[data-current-variant]');
          if (variantInput) variantInput.value = variant.id;
          // update displayed price
          updateSelectedPriceById(variant.id);
          // update preorder button state
          updatePreorderButton(sectionEl, variant);
          // reveal the selected variant's gallery media (size-specific shots)
          updateGalleryForVariant(sectionEl, variant);
        } catch (e) { /* ignore */ }
      });

      // Parse per-section preorder map (fallback detection when inventory fields are missing client-side)
      try {
        var preorderJsonEl = sectionEl.querySelector('[data-variant-preorder]');
        if (preorderJsonEl) {
          try {
            sectionEl._product2025PreorderMap = JSON.parse(preorderJsonEl.textContent || '{}');
          } catch (e) {
            sectionEl._product2025PreorderMap = {};
          }
        } else {
          sectionEl._product2025PreorderMap = {};
        }
      } catch (e) { sectionEl._product2025PreorderMap = {}; }

      // Call updatePreorderButton once on init so client UI matches server-rendered button immediately
      try {
        var currentVariantInput = sectionEl.querySelector('input[data-current-variant]');
        var currentVariantId = currentVariantInput ? currentVariantInput.value : null;
        var initialVariant = null;
        if (currentVariantId && variants && variants.length) {
          initialVariant = variants.find(function(v){ return String(v.id) === String(currentVariantId); });
        }
        if (!initialVariant && variants && variants.length) initialVariant = variants[0];
        if (initialVariant) {
          updatePreorderButton(sectionEl, initialVariant);
          updateGalleryForVariant(sectionEl, initialVariant);
        }
      } catch (e) { /* ignore */ }

      // Also listen for explicit price change events if fired
      sectionEl.addEventListener('variantPriceChange', function(evt) {
        try {
          var variant = evt && evt.detail && evt.detail.variant;
          if (!variant) return;
          updateSelectedPriceById(variant.id);
        } catch (e) { /* ignore */ }
      });

      // Initialize Ajax add-to-cart handling so the cart drawer opens instead of navigating
      var formEl = sectionEl.querySelector('form.Product2025Form');

      // Try multiple selectors to find the button
      var buttonEl = sectionEl.querySelector('button[data-add-to-cart]') ||
                     sectionEl.querySelector('button[data-cart-drawer="true"]') ||
                     sectionEl.querySelector('button.Product2025AddToCart') ||
                     sectionEl.querySelector('button.Product2025CartDrawer') ||
                     sectionEl.querySelector('button.btn--full') ||
                     sectionEl.querySelector('button.add-to-cart') ||
                     sectionEl.querySelector('button[data-payment-button]') ||
                     sectionEl.querySelector('form.Product2025Form button[type="submit"]') ||
                     sectionEl.querySelector('form.Product2025Form input[type="submit"]') ||
                     sectionEl.querySelector('button[name="add"]') ||
                     sectionEl.querySelector('input[name="add"]');


      // Debug all forms in the section
      var allForms = sectionEl.querySelectorAll('form');
      allForms.forEach(function(form, index) {
      });

      // Debug all buttons in the section
      var allButtons = sectionEl.querySelectorAll('button, input[type="submit"]');
      allButtons.forEach(function(btn, index) {

        // Check if this matches the problematic button structure
        if (btn.className.includes('btn--full') && btn.className.includes('add-to-cart') && btn.className.includes('Product2025CartDrawer')) {
        }
      });


      if (buttonEl) {
      }

      if (formEl && buttonEl) {

        // Always add our fallback handler first - this ensures cart drawer works
        addFormSubmissionHandler(formEl, buttonEl);

        // Try to use theme.AjaxProduct if available (but don't rely on it)
      if (theme && theme.AjaxProduct) {
          try {
            // Build selector string from all possible button selectors
            var buttonSelectors = [
              'button[data-add-to-cart]',
              'button[data-cart-drawer="true"]',
              'button.Product2025AddToCart',
              'button.Product2025CartDrawer',
              'button.btn--full',
              'button.add-to-cart',
              'button[data-payment-button]',
              'form.Product2025Form button[type="submit"]',
              'form.Product2025Form input[type="submit"]',
              'button[name="add"]',
              'input[name="add"]'
            ].join(', ');

            sectionEl._product2025Ajax = new theme.AjaxProduct(formEl, buttonSelectors);

            // Listen for the ajaxProduct:added event to ensure cart drawer opens
            sectionEl.addEventListener('ajaxProduct:added', function() {
              setTimeout(function() {
                if (window.Shopify && Shopify.cart) {
                  try {
                    Shopify.cart.show();
                  } catch (e) {
                  }
                }
              }, 100);
            });
          } catch (e) {
            // Continue with our direct handler - it's more reliable
          }
        } else {
        }
      } else {
        // Even if no form, try to add fallback to any button we found
        if (buttonEl && !formEl) {
          addCartDrawerFallback(buttonEl);
        }
      }

      // Direct form submission handler - use theme's cart drawer system
      function addFormSubmissionHandler(formEl, buttonEl) {

        var cartDrawerOpened = false;

        // Prevent default form submission and handle it ourselves
        formEl.addEventListener('submit', function(e) {

          e.preventDefault();
          e.stopPropagation();

          cartDrawerOpened = false;

          // Try to trigger the theme's cart drawer system
          try {
            // First try the theme's cart drawer event
            document.dispatchEvent(new CustomEvent('cart:open'));

            // If theme.CartDrawer exists, try to use it directly
            if (window.theme && window.theme.cartDrawer) {
              window.theme.cartDrawer.open();
              cartDrawerOpened = true;
            } else if (window.theme && window.theme.CartDrawer) {
              // If it's a class, try to find an instance or create one
              var cartDrawerEl = document.getElementById('CartDrawer');
              if (cartDrawerEl) {
                var drawer = new window.theme.Drawers('CartDrawer', 'cart');
                drawer.open();
                cartDrawerOpened = true;
              }
            }
          } catch (e) {
          }

          // Check if cart drawer opened successfully
          setTimeout(function() {
            var cartDrawer = document.getElementById('CartDrawer');
            var isDrawerOpen = cartDrawer && cartDrawer.classList.contains('is-open') ||
                              (cartDrawer && getComputedStyle(cartDrawer).display !== 'none');

            if (cartDrawerOpened && isDrawerOpen) {
              // Cart drawer is open, cart should be updated via AJAX, no navigation needed
            } else {
              // Try to update cart via theme.AjaxProduct if available
              if (theme && theme.AjaxProduct && formEl) {
                try {
                  // Create a temporary AjaxProduct instance to update cart without navigation
                  var tempAjax = new theme.AjaxProduct(formEl, 'button[data-add-to-cart], button[data-cart-drawer="true"], button.Product2025AddToCart, button.Product2025CartDrawer, button.btn--full, button.add-to-cart, button[data-payment-button]');
                } catch (e) {
                }
              }
            }

            // Product 2025 NEVER navigates to cart page - cart should be updated via AJAX only
          }, 200);
        });

        // Also handle button clicks directly
          buttonEl.addEventListener('click', function(e) {

          // Try to trigger cart drawer immediately on click
          try {
            document.dispatchEvent(new CustomEvent('cart:open'));

            if (window.theme && window.theme.cartDrawer) {
              window.theme.cartDrawer.open();
              cartDrawerOpened = true;
            }
          } catch (e) {
          }
        });

        // Also handle any programmatic form submissions
        var originalSubmit = formEl.submit;
        formEl.submit = function() {

          // Try to show cart drawer
          try {
            document.dispatchEvent(new CustomEvent('cart:open'));
            if (window.theme && window.theme.cartDrawer) {
              window.theme.cartDrawer.open();
            }
          } catch (e) {
          }

          // Update cart via AJAX without navigation
          if (theme && theme.AjaxProduct && formEl) {
            try {
              var tempAjax = new theme.AjaxProduct(formEl, 'button[data-add-to-cart], button[data-cart-drawer="true"], button.Product2025AddToCart, button.Product2025CartDrawer, button.btn--full, button.add-to-cart, button[data-payment-button]');
            } catch (e) {
            }
          }

          // Product 2025 NEVER navigates to cart page
          return false;
        };
      }

      // Handle dynamic checkout buttons (payment buttons)
      initializeDynamicCheckoutButtons(sectionEl);
    } catch (e) {
      // ignore if theme.Variants isn't available
    }
  });

  // Also observe changes to the hidden variant input (in case other scripts update it)
  var variantInputEl = document.querySelector('input[data-current-variant]');
  if (variantInputEl) {
    variantInputEl.addEventListener('change', function() {
      updateSelectedPriceById(this.value);
    });
  }

  // Global fallback: catch any add-to-cart buttons that might have been missed
  // This runs after all section-specific initialization
  setTimeout(function() {

    // Debug all forms on the page
    var allPageForms = document.querySelectorAll('form');
    allPageForms.forEach(function(form, index) {
    });

    // Debug all buttons on the page
    var allPageButtons = document.querySelectorAll('button, input[type="submit"]');
    allPageButtons.forEach(function(btn, index) {
    });

    // Build comprehensive selector for all possible button types
    var globalButtonSelectors = [
      'button[data-add-to-cart]',
      'button[data-cart-drawer="true"]',
      'button.Product2025AddToCart',
      'button.Product2025CartDrawer',
      'button.btn--full',
      'button.add-to-cart',
      'button[data-payment-button]',
      'form.Product2025Form button[type="submit"]',
      'form.Product2025Form input[type="submit"]',
      'button[name="add"]',
      'input[name="add"]'
    ];

    var globalButtons = document.querySelectorAll(globalButtonSelectors.join(', '));

    globalButtons.forEach(function(button) {
      if (!button.hasAttribute('data-product2025-cart-drawer-handled')) {
        addCartDrawerFallback(button);
        button.setAttribute('data-product2025-cart-drawer-handled', 'true');
      }
    });

    // Also handle any forms that might not have been caught
    allPageForms.forEach(function(form) {
      if (!form.hasAttribute('data-product2025-form-handled')) {
        addGlobalFormHandler(form);
        form.setAttribute('data-product2025-form-handled', 'true');
      }
    });
  }, 1000);

  // Set up mutation observer to catch dynamically added or modified buttons
  // Add a small delay to avoid conflicts with other observers
  setTimeout(function() {
    var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the new element is a button we should handle
            var buttonSelectors = [
              'button[data-add-to-cart]',
              'button[data-cart-drawer="true"]',
              'button.Product2025AddToCart',
              'button.Product2025CartDrawer',
              'button.btn--full',
              'button.add-to-cart',
              'button[data-payment-button]',
              'form.Product2025Form button[type="submit"]',
              'form.Product2025Form input[type="submit"]',
              'button[name="add"]',
              'input[name="add"]'
            ];

            if (node.matches && buttonSelectors.some(selector => node.matches(selector))) {
              if (!node.hasAttribute('data-product2025-cart-drawer-handled')) {
                addCartDrawerFallback(node);
                node.setAttribute('data-product2025-cart-drawer-handled', 'true');
              }
            }

            // Also check child elements
            var buttons = node.querySelectorAll && node.querySelectorAll(buttonSelectors.join(', '));
            buttons.forEach(function(button) {
              if (!button.hasAttribute('data-product2025-cart-drawer-handled')) {
                addCartDrawerFallback(button);
                button.setAttribute('data-product2025-cart-drawer-handled', 'true');
              }
            });
          }
        });
      }
    });
  });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }, 500); // End setTimeout for mutation observer

  // Global catch-all for any form submissions that might bypass section handlers
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.closest('.Product2025Section')) {

      e.preventDefault();
      e.stopPropagation();

      // Try to trigger cart drawer
      try {
        document.dispatchEvent(new CustomEvent('cart:open'));
        if (window.theme && window.theme.cartDrawer) {
          window.theme.cartDrawer.open();
        }
      } catch (err) {
      }

    }
  });

  // Global catch-all for button clicks
  document.addEventListener('click', function(e) {
    var button = e.target;
    if (button && button.closest('.Product2025Section')) {
      // Check if this is a submit button in a Product 2025 section
      if (button.type === 'submit' || button.name === 'add' || button.className.includes('add-to-cart')) {

        // Try to trigger cart drawer immediately
        try {
          document.dispatchEvent(new CustomEvent('cart:open'));
          if (window.theme && window.theme.cartDrawer) {
            window.theme.cartDrawer.open();
          }
        } catch (err) {
        }
      }
    }
  });

});

// Debug helper: call toggleProduct2025Debug() from the console to toggle red/blue bounding boxes
function toggleProduct2025Debug() {
  var section = document.querySelector('.Product2025Section');
  if (!section) return false;
  section.classList.toggle('debug');
  return section.classList.contains('debug');
}

// expose for console convenience
window.toggleProduct2025Debug = toggleProduct2025Debug;

// Helper: keep a map of variant id -> price (string formatted via Liquid in the section)
function updateSelectedPriceById(variantId) {
  try {
    if (!variantId) return;
    var priceEl = document.querySelector('[data-selected-price]');
    if (!priceEl) return;
    var priceMapEl = document.querySelector('[data-variant-price-map]');
    var priceMap = priceMapEl ? JSON.parse(priceMapEl.textContent) : {};
    // ensure we lookup using a string key (Liquid rendered keys are strings)
    var key = (typeof variantId === 'string') ? variantId : String(variantId);
    var formatted = priceMap[key];
    // fallback: try numeric key if needed
    if (!formatted && typeof variantId !== 'string') formatted = priceMap[String(Number(variantId))];
    if (formatted) {
      priceEl.textContent = formatted;
    }
    // Keep the Insider member price in sync with the selected variant
    var memberEl = document.querySelector('[data-selected-member-price]');
    if (memberEl) {
      var memberMapEl = document.querySelector('[data-variant-member-price-map]');
      var memberMap = memberMapEl ? JSON.parse(memberMapEl.textContent) : {};
      var mFormatted = memberMap[key];
      if (!mFormatted && typeof variantId !== 'string') mFormatted = memberMap[String(Number(variantId))];
      if (mFormatted) memberEl.textContent = mFormatted;
    }
  } catch (e) {
    // ignore
  }
}

// Initialize dynamic checkout buttons (payment buttons) to trigger cart drawer
function initializeDynamicCheckoutButtons(sectionEl) {
  if (!sectionEl) return;


  // Function to find and handle dynamic checkout buttons
  function handleDynamicCheckoutButtons() {
    // Look for various selectors that dynamic checkout buttons might use
    var selectors = [
      '.payment-buttons button',
      '.payment-buttons [data-shopify-payment-button]',
      '.payment-buttons input[type="button"]',
      '.payment-buttons input[type="submit"]',
      '.payment-buttons [role="button"]',
      '[data-payment-button]',
      '.shopify-payment-button',
      'button[data-payment-button]',
      'input[data-payment-button]',
      'button[data-shopify-payment-button]',
      'input[data-shopify-payment-button]'
    ];

    var foundButtons = false;
    selectors.forEach(function(selector) {
      var buttons = sectionEl.querySelectorAll(selector);
      buttons.forEach(function(button) {
        if (!button.hasAttribute('data-product2025-handled')) {

          button.addEventListener('click', function(e) {
            // Trigger cart drawer
            setTimeout(function() {
              if (window.Shopify && Shopify.cart) {
                try {
                  Shopify.cart.show();
                } catch (e) {
                }
              }
            }, 100);
          });

          button.setAttribute('data-product2025-handled', 'true');
          foundButtons = true;
        }
      });
    });

    return foundButtons;
  }

  // Try to handle buttons immediately
  if (!handleDynamicCheckoutButtons()) {
    // If no buttons found, set up a mutation observer to watch for dynamically loaded buttons

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if the new element or its children contain payment buttons
              if (handleDynamicCheckoutButtons()) {
                observer.disconnect(); // Stop observing once we find and handle buttons
              }
            }
          });
        }
      });
    });

    // Start observing the section for changes
    observer.observe(sectionEl, {
      childList: true,
      subtree: true
    });

    // Also observe the entire document in case buttons are added outside the section
    var docObserver = new MutationObserver(function(mutations) {
      var sectionFoundButtons = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if this node is within our section
              if (sectionEl.contains(node)) {
                if (handleDynamicCheckoutButtons()) {
                  sectionFoundButtons = true;
                }
              }
            }
          });
        }
      });
      if (sectionFoundButtons) {
        docObserver.disconnect();
      }
    });

    docObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

// Play-on-hover for info gallery videos
document.addEventListener('DOMContentLoaded', function() {
  function initPlayOnHover() {
    var galleries = document.querySelectorAll('.Product2025InfoGallery');
    galleries.forEach(function(gallery) {
      var videos = gallery.querySelectorAll('video.Product2025InfoThumbImg');
      videos.forEach(function(video) {
        // If the video is autoplaying via attribute, skip hover behavior
        if (video.hasAttribute('autoplay')) return;

        // Avoid adding duplicate listeners
        if (video._p2025HoverInit) return;
        video._p2025HoverInit = true;

        video.addEventListener('mouseenter', function() {
          try { video.play(); } catch (e) { /* ignore play errors */ }
        });

        video.addEventListener('mouseleave', function() {
          try { video.pause(); video.currentTime = 0; } catch (e) { /* ignore pause errors */ }
        });
      });
    });
  }

  initPlayOnHover();

  // Watch for dynamically injected gallery/video elements
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.Product2025InfoGallery')) {
          initPlayOnHover();
          return;
        }
        if (node.querySelectorAll) {
          var vids = node.querySelectorAll('.Product2025InfoGallery video.Product2025InfoThumbImg');
          if (vids && vids.length) initPlayOnHover();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
